export default {
  SET_UPDATE_PROJECTS: 'SET_UPDATE_PROJECTS',
};
